export const isLink = (element) => element.type === 'link';
